import { useListStore } from '../../hooks';
import { ComponentListView } from '../../components/ComponentListView';

export const ComponentList = () => {
  const { releaseComponents, onOpenModal } = useListStore();

  return (
    <ComponentListView
      listItems={releaseComponents}
      handleEditOpenModal={onOpenModal}
    />
  );
};
